import React, {useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'lib/i18n';
import Button from 'components/common/button/Button';
import {describeAuthError} from 'services/auth-errors';

function AuthErrorPage() {
  const {t} = useTranslation();
  const history = useHistory();
  const error = history.location?.state?.error;

  const message = useMemo(() => {
    if (!error) {
      return t('illustratorTranslation:generic error');
    }

    if (error.message && String(error.message).trim()) {
      return error.message;
    }

    return describeAuthError(error).message;
  }, [error, t]);

  const handleRetry = useCallback(() => {
    window.location.assign('/');
  }, []);

  return (
    <>
      <h2 data-testid="auth-error-page">{message}</h2>
      <Button onClick={handleRetry} data-testid="auth-error-retry">
        {t('illustratorTranslation:auth error retry')}
      </Button>
    </>
  );
}

export default AuthErrorPage;
